import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Response } from '../../shared/models/response.model';
import { Interrelation } from './models/interrelation.model';
import { InterrelationCreateRequest } from './requests/create-request';
import { InterrelationUpdateRequest } from './requests/update-request';

@Injectable({
  providedIn: 'root',
})
export class InterrelationService {
  #http = inject(HttpClient);

  readonly BASE_URL = `/interrelations`;

  findAll(idCartographie: string, idsPhase?: string[]) {
    let params = new HttpParams().append('idCartographie', idCartographie);

    if (idsPhase) {
      idsPhase.forEach((id) => (params = params.append('idsPhase', id)));
    }

    return this.#http.get<Response<Interrelation>>(this.BASE_URL, { params: params });
  }

  findById(idInterrelation: string): Observable<Interrelation> {
    return this.#http.get<Interrelation>(this.BASE_URL + '/' + idInterrelation);
  }

  créer(data: InterrelationCreateRequest) {
    return this.#http.post<void>(this.BASE_URL, data);
  }

  modifier(data: InterrelationUpdateRequest) {
    return this.#http.put<void>(this.BASE_URL, data);
  }

  supprimer(idInterrelation: string) {
    return this.#http.delete<void>(this.BASE_URL + '/' + idInterrelation);
  }
}
